"use client";
import { useEffect, useState } from "react";
import ArticleCard from "./ArticleCard";
import { type IArticle } from "@/lib/article-utils";
import { getFileUrl } from "@/lib/pocketbase";

import { useArticles } from "@/context/ArticlesContext";

const PreviousArticles = () => {
  const [articlesArray, setArticlesArray] = useState<[string, IArticle[]][]>(
    []
  );
  const [summaryLevel, setSummaryLevel] = useState("beginner");
  const [articleStatus, setArticleStatus] = useState<number | undefined>(
    undefined
  );

  const { articlesByDate } = useArticles(articleStatus);

  const articleEntries = Array.from(articlesByDate.entries())
    .filter(([articles]) => articles.length > 0)
    .sort(([a], [b]) => new Date(b).getTime() - new Date(a).getTime());

  const handleSummarriesLevelChange = (level: string) => {
    setSummaryLevel(level);
  };
  const handleArticleStatusFilter = (status: string) => {
    if (status == "all") setArticleStatus(undefined);
    else if (status == "two") setArticleStatus(0);
    else if (status == "one") setArticleStatus(1);
    else setArticleStatus(2);
  };

  useEffect(() => {
    setArticlesArray(articleEntries);
  }, [articleStatus]);


  return (
    <div className="container mx-auto">
      <div className="mx-6 lg:mx-12">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between my-6 lg:my-12">
          <div className="flex items-center mb-4 lg:mb-0 reading-status-filters border-collapse">
            <button
              onClick={() => handleArticleStatusFilter("all")}
              className={`reading-status-filter-btn px-8 lg:px-4 max-sm:text-sm max-sm:py-3 max- ${
                articleStatus == undefined && "active"
              }`}
            >
              All
            </button>
            <button
              onClick={() => handleArticleStatusFilter("two")}
              className={`reading-status-filter-btn px-8 lg:px-4 max-sm:text-sm max-sm:py-3 max- ${
                articleStatus == 0 && "active"
              }`}
            >
              2 Tries Left
            </button>
            <button
              onClick={() => handleArticleStatusFilter("one")}
              className={`reading-status-filter-btn px-8 lg:px-4 max-sm:text-sm max-sm:py-3 max- ${
                articleStatus == 1 && "active"
              }`}
            >
              1 Try Left
            </button>
            <button
              onClick={() => handleArticleStatusFilter("zero")}
              className={`reading-status-filter-btn px-8 lg:px-4 max-sm:text-sm max-sm:py-3 max- ${
                articleStatus == 2 && "active"
              }`}
            >
              0 Tries
            </button>
          </div>
          <div className="flex items-center">
            <button
              className={`articles-level-switcher-btn ${
                summaryLevel == "beginner" && "active"
              }`}
              onClick={() => handleSummarriesLevelChange("beginner")}
            >
              Beginner
            </button>
            <button
              className={`articles-level-switcher-btn ${
                summaryLevel == "intermediate" && "active"
              }`}
              onClick={() => handleSummarriesLevelChange("intermediate")}
            >
              Intermediate
            </button>
            <button
              className={`articles-level-switcher-btn ${
                summaryLevel == "advanced" && "active"
              }`}
              onClick={() => handleSummarriesLevelChange("advanced")}
            >
              Advanced
            </button>
          </div>
        </div>

        <div className="articles-grid">
          {articlesArray.map(([date, articles], _index) =>
            articles
              .slice(0, 5)
              .map((article) => (
                <ArticleCard
                  id={article.id}
                  key={article.id}
                  slug={article.slug}
                  summaryLevel={summaryLevel}
                  tag={
                    article.expand?.section
                      ? article.expand.section.name
                      : "Science & Technology"
                  }
                  date={new Date(date)}
                  image={
                    article.expand?.section
                      ? getFileUrl(
                          "sections",
                          article.expand.section.id,
                          article.expand.section.image
                        )
                      : "/assets/articles/article-1.png"
                  }
                  title={article.title}
                  readingStatus={article.quiz_taken ?? 0}
                  wordCount={article.word_count}
                />
              ))
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviousArticles;
